import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_navbar = _resolveComponent("navbar")!

  return (_openBlock(), _createElementBlock("div", {
    class: "vue-megamenu",
    onMouseleave: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
  }, [
    (_ctx.isOpen || _ctx.isWideScreen())
      ? (_openBlock(), _createBlock(_component_navbar, {
          key: 0,
          activeCategory: _ctx.activeCategory
        }, null, 8, ["activeCategory"]))
      : _createCommentVNode("", true)
  ], 32))
}